import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["theme", "currentTag", "defaultTag", "currentColor", "isBold", "isItalic", "isUnderlined", "alignment", "colorPallet", "className", "onTagChange", "onAlignmentChange", "onStyleChange", "onClose"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';
import React, { useState, useRef, forwardRef, useEffect, useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';
import { autoUpdate, flip, offset, shift, useClick, useDismiss, useFloating, useInteractions, FloatingPortal } from '@floating-ui/react';
import { ALIGNMENTS, TAGS, TAG_LABELS } from './interfaces';
import design from '@/config/design';
import featureFlags from '@/config/features';
import useComposedRefs from '@/hooks/useComposeRefs';
import usePlainPaste from '@/hooks/usePlainPaste';
import { deleteNotTruthey, getObjectDiff } from '@/utils/objects';
import { triggerEditTheme } from '@/components/Editor/ThemeEditor/utils';
import { useTheme } from '@/components/widget/Layout/ThemeProvider';
import { ButtonV2 as Button } from '@/components/Button';
import Select from '@/components/FormElements/Select';
import InlineColorPicker from '@/components/Editor/Form/fields/common/InlineColorPicker';
import commonStyles from '@/components/widget/visualizations/styles/common.module.scss';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var FormatBoldIcon = function FormatBoldIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.33325 6.66667H8.66659C10.8757 6.66667 12.6666 8.45753 12.6666 10.6667C12.6666 12.8758 10.8757 14.6667 8.66659 14.6667H5.33325C4.22868 14.6667 3.33325 13.7712 3.33325 12.6667V6.66667ZM4.66659 8.00001V12.6667C4.66659 13.0349 4.96506 13.3333 5.33325 13.3333H8.66659C10.1393 13.3333 11.3333 12.1394 11.3333 10.6667C11.3333 9.19391 10.1393 8.00001 8.66659 8.00001H4.66659Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.33325 3.33333C3.33325 2.22876 4.22868 1.33333 5.33325 1.33333H7.99992C9.84087 1.33333 11.3333 2.82571 11.3333 4.66666C11.3333 6.50761 9.84087 7.99999 7.99992 7.99999H3.33325V3.33333ZM5.33325 2.66666C4.96506 2.66666 4.66659 2.96514 4.66659 3.33333V6.66666H7.99992C9.10449 6.66666 9.99992 5.77123 9.99992 4.66666C9.99992 3.56209 9.10449 2.66666 7.99992 2.66666H5.33325Z",
      fill: "black"
    })]
  }));
};

FormatBoldIcon.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var FormatItalicIcon = function FormatItalicIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.47785 1.34921C9.83727 1.42908 10.0639 1.7852 9.98402 2.14462L7.31736 14.1446C7.23749 14.504 6.88137 14.7307 6.52195 14.6508C6.16252 14.5709 5.9359 14.2148 6.01577 13.8554L8.68244 1.85538C8.76231 1.49596 9.11843 1.26934 9.47785 1.34921Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      d: "M6.00008 1.33333C5.63189 1.33333 5.33341 1.63181 5.33341 1.99999C5.33341 2.36818 5.63189 2.66666 6.00008 2.66666H12.6667C13.0349 2.66666 13.3334 2.36818 13.3334 1.99999C13.3334 1.63181 13.0349 1.33333 12.6667 1.33333H6.00008Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      d: "M3.33341 13.3333C2.96522 13.3333 2.66675 13.6318 2.66675 14C2.66675 14.3682 2.96522 14.6667 3.33341 14.6667H10.0001C10.3683 14.6667 10.6667 14.3682 10.6667 14C10.6667 13.6318 10.3683 13.3333 10.0001 13.3333H3.33341Z",
      fill: "black"
    })]
  }));
};

FormatItalicIcon.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var FormatUnderlineIcon = function FormatUnderlineIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M2.66675 14C2.66675 13.6318 2.96522 13.3333 3.33341 13.3333H12.6667C13.0349 13.3333 13.3334 13.6318 13.3334 14C13.3334 14.3682 13.0349 14.6667 12.6667 14.6667H3.33341C2.96522 14.6667 2.66675 14.3682 2.66675 14Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.99992 1.33333C4.36811 1.33333 4.66659 1.63181 4.66659 1.99999V7.33333C4.66659 9.17428 6.15897 10.6667 7.99992 10.6667C9.84087 10.6667 11.3333 9.17428 11.3333 7.33333V1.99999C11.3333 1.63181 11.6317 1.33333 11.9999 1.33333C12.3681 1.33333 12.6666 1.63181 12.6666 1.99999V7.33333C12.6666 9.91066 10.5772 12 7.99992 12C5.42259 12 3.33325 9.91066 3.33325 7.33333V1.99999C3.33325 1.63181 3.63173 1.33333 3.99992 1.33333Z",
      fill: "black"
    })]
  }));
};

FormatUnderlineIcon.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var TextAlignLeftIcon = function TextAlignLeftIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 2.66667C2 2.29848 2.29848 2 2.66667 2H13.3333C13.7015 2 14 2.29848 14 2.66667C14 3.03486 13.7015 3.33333 13.3333 3.33333H2.66667C2.29848 3.33333 2 3.03486 2 2.66667ZM2 8C2 7.63181 2.29848 7.33333 2.66667 7.33333H13.3333C13.7015 7.33333 14 7.63181 14 8C14 8.36819 13.7015 8.66667 13.3333 8.66667H2.66667C2.29848 8.66667 2 8.36819 2 8ZM2.66667 12.6667C2.29848 12.6667 2 12.9651 2 13.3333C2 13.7015 2.29848 14 2.66667 14H13.3333C13.7015 14 14 13.7015 14 13.3333C14 12.9651 13.7015 12.6667 13.3333 12.6667H2.66667ZM2 5.33333C2 4.96514 2.29848 4.66667 2.66667 4.66667H8C8.36819 4.66667 8.66667 4.96514 8.66667 5.33333C8.66667 5.70152 8.36819 6 8 6H2.66667C2.29848 6 2 5.70152 2 5.33333ZM2.66667 10C2.29848 10 2 10.2985 2 10.6667C2 11.0349 2.29848 11.3333 2.66667 11.3333H8C8.36819 11.3333 8.66667 11.0349 8.66667 10.6667C8.66667 10.2985 8.36819 10 8 10H2.66667Z",
      fill: "black"
    })
  }));
};

TextAlignLeftIcon.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var TextAlignCenterIcon = function TextAlignCenterIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 2.66667C2 2.29848 2.29848 2 2.66667 2H13.3333C13.7015 2 14 2.29848 14 2.66667C14 3.03486 13.7015 3.33333 13.3333 3.33333H2.66667C2.29848 3.33333 2 3.03486 2 2.66667ZM2 8C2 7.63181 2.29848 7.33333 2.66667 7.33333H13.3333C13.7015 7.33333 14 7.63181 14 8C14 8.36819 13.7015 8.66667 13.3333 8.66667H2.66667C2.29848 8.66667 2 8.36819 2 8ZM2.66667 12.6667C2.29848 12.6667 2 12.9651 2 13.3333C2 13.7015 2.29848 14 2.66667 14H13.3333C13.7015 14 14 13.7015 14 13.3333C14 12.9651 13.7015 12.6667 13.3333 12.6667H2.66667ZM4.66667 5.33333C4.66667 4.96514 4.96514 4.66667 5.33333 4.66667H10.6667C11.0349 4.66667 11.3333 4.96514 11.3333 5.33333C11.3333 5.70152 11.0349 6 10.6667 6H5.33333C4.96514 6 4.66667 5.70152 4.66667 5.33333ZM5.33333 10C4.96514 10 4.66667 10.2985 4.66667 10.6667C4.66667 11.0349 4.96514 11.3333 5.33333 11.3333H10.6667C11.0349 11.3333 11.3333 11.0349 11.3333 10.6667C11.3333 10.2985 11.0349 10 10.6667 10H5.33333Z",
      fill: "black"
    })
  }));
};

TextAlignCenterIcon.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var EditFilledIcon = function EditFilledIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M2.66675 14C2.66675 13.6318 2.96522 13.3333 3.33341 13.3333H12.6667C13.0349 13.3333 13.3334 13.6318 13.3334 14C13.3334 14.3682 13.0349 14.6667 12.6667 14.6667H3.33341C2.96522 14.6667 2.66675 14.3682 2.66675 14Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.95953 3.56908C7.82935 3.43891 7.6183 3.43891 7.48812 3.56908L4.90232 6.15485C4.77215 6.28503 4.77214 6.49608 4.90232 6.62626L8.04039 9.76433C8.17057 9.8945 8.38162 9.8945 8.51179 9.76433L11.0976 7.17856C11.2278 7.04838 11.2278 6.83733 11.0976 6.70715L7.95953 3.56908Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.09399 10.9992C7.20346 10.9688 7.22387 10.8334 7.14353 10.7531L3.91355 7.52311C3.83321 7.44277 3.69787 7.46318 3.66744 7.57265L2.69585 11.0678C2.54302 11.6176 3.04901 12.1236 3.59879 11.9708L7.09399 10.9992Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.13907 1.91813C9.92012 1.13709 11.1864 1.13709 11.9675 1.91814L12.7485 2.69919C13.5296 3.48024 13.5296 4.74658 12.7485 5.52762L12.5118 5.76435C12.3816 5.89452 12.1706 5.89452 12.0404 5.76435L8.90232 2.62628C8.77214 2.4961 8.77214 2.28505 8.90232 2.15487L9.13907 1.91813Z",
      fill: "black"
    })]
  }));
};

EditFilledIcon.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const ELEMENT_GROUP = 'typography';
const DEFAULT_TAG = 'h6';
const DEFAULT_ALIGNMENT = 'left';
const DEFAULT_STYLES = {
  bold: false,
  italic: false,
  underlined: false
};
const alignmentIcons = {
  left: /*#__PURE__*/_jsx(TextAlignLeftIcon, {}),
  center: /*#__PURE__*/_jsx(TextAlignCenterIcon, {})
};
const Toolbar = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    theme,
    currentTag,
    defaultTag = DEFAULT_TAG,
    currentColor,
    isBold,
    isItalic,
    isUnderlined,
    alignment = 'left',
    colorPallet,
    className,
    onTagChange,
    onAlignmentChange,
    onStyleChange,
    onClose
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  // Responsive queries
  const isCompactToolbar = useMediaQuery({
    maxWidth: 440
  });
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
    ref: ref,
    className: clsx(styles.toolbar, {
      [styles['toolbar--compact']]: isCompactToolbar
    })
  }, props), {}, {
    children: [/*#__PURE__*/_jsx(Select, {
      value: currentTag || defaultTag,
      className: styles.select,
      onChange: e => onTagChange(e.currentTarget.value),
      children: TAGS.map(tag => {
        let label = TAG_LABELS[tag] || tag.toUpperCase();
        if (tag === defaultTag) label += ' (Default)';
        return /*#__PURE__*/_jsx("option", {
          value: tag,
          children: label
        }, tag);
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.buttonGroup,
      children: [/*#__PURE__*/_jsx("button", {
        className: clsx(styles.toolbarButton, {
          [styles['toolbarButton--active']]: isBold
        }),
        onClick: () => onStyleChange('bold', !isBold),
        title: "Bold",
        children: /*#__PURE__*/_jsx(FormatBoldIcon, {})
      }), /*#__PURE__*/_jsx("button", {
        className: clsx(styles.toolbarButton, {
          [styles['toolbarButton--active']]: isItalic
        }),
        onClick: () => onStyleChange('italic', !isItalic),
        title: "Italic",
        children: /*#__PURE__*/_jsx(FormatItalicIcon, {})
      }), /*#__PURE__*/_jsx("button", {
        className: clsx(styles.toolbarButton, {
          [styles['toolbarButton--active']]: isUnderlined
        }),
        onClick: () => onStyleChange('underlined', !isUnderlined),
        title: "Underline",
        children: /*#__PURE__*/_jsx(FormatUnderlineIcon, {})
      })]
    }), /*#__PURE__*/_jsx(InlineColorPicker, {
      syncDefaultValue: true,
      defaultValue: currentColor,
      colorPallet: colorPallet,
      onChange: color => onStyleChange('color', color)
    }), /*#__PURE__*/_jsx("div", {
      className: styles.buttonGroup,
      children: ALIGNMENTS.map(align => /*#__PURE__*/_jsx("button", {
        className: clsx(styles.toolbarButton, {
          [styles['toolbarButton--active']]: alignment === align
        }),
        onClick: () => onAlignmentChange(align),
        title: `Align ${align}`,
        children: alignmentIcons[align]
      }, `toolbar-${align}`))
    }), featureFlags.themeEditing ? /*#__PURE__*/_jsx(Button, _objectSpread({
      size: "small",
      variant: "text",
      leftIcon: /*#__PURE__*/_jsx(EditFilledIcon, {}),
      onClick: () => {
        triggerEditTheme({
          element: currentTag || DEFAULT_TAG,
          elementGroup: ELEMENT_GROUP
        });
        onClose();
      }
    }, !isCompactToolbar && {
      children: 'Theme'
    })) : null]
  }));
});
Toolbar.displayName = 'Toolbar';

const EditableText = _ref2 => {
  let {
    id,
    editable = false,
    className = '',
    placeholder = 'Start typing...',
    toolbarPlacement = 'top',
    defaultTag = DEFAULT_TAG,
    initialContent: defaultContent = '',
    initialTag = null,
    initialAlignment = DEFAULT_ALIGNMENT,
    initialStyles = DEFAULT_STYLES,
    colorPallet,
    onChange,
    onOpenChange
  } = _ref2;
  const {
    theme
  } = useTheme();
  const containerRef = useRef(null);
  const editableRef = useRef(null);
  const {
    0: isToolbarOpen,
    1: setToolbarOpen
  } = useState(false);
  const {
    0: initialContent,
    1: setInitialContent
  } = useState(defaultContent);
  const {
    0: content,
    1: setContent
  } = useState(initialContent);
  const {
    0: tag,
    1: setTag
  } = useState(initialTag || defaultTag);
  const {
    0: alignment,
    1: setAlignment
  } = useState(initialAlignment);
  const {
    0: textStyles,
    1: setTextStyles
  } = useState(initialStyles); // Responsive queries

  const isMobile = useMediaQuery({
    maxWidth: 380
  });

  const handleOpenChange = open => {
    setToolbarOpen(open);
    onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(open);
  }; // Handle menu positioning


  const {
    refs,
    floatingStyles,
    context
  } = useFloating({
    open: isToolbarOpen,
    onOpenChange: handleOpenChange,
    placement: alignment === 'center' ? toolbarPlacement : `${toolbarPlacement}-start`,
    whileElementsMounted: autoUpdate,
    middleware: [offset({
      mainAxis: isMobile ? 6 : 8,
      crossAxis: alignment === 'center' ? 0 : -4
    }), flip(), shift()]
  }); // open menu on button click

  const click = useClick(context, {
    toggle: false
  }); // close menu on outside click or escape key

  const dismiss = useDismiss(context);
  const {
    getReferenceProps,
    getFloatingProps
  } = useInteractions([click, dismiss]);
  const {
    handlePaste
  } = usePlainPaste({
    elementRef: refs.reference,
    onChange: newContent => {
      setContent(newContent);
      notifyChange({
        content: newContent,
        tag,
        alignment,
        styles: textStyles
      });
    }
  });

  const handleContentChange = e => {
    const newContent = e.target.innerText;
    setContent(newContent);
    notifyChange({
      content: newContent,
      tag,
      alignment,
      styles: textStyles
    });
  };

  const notifyChange = data => {
    if (onChange) {
      // Save only changed styles
      const differedStyles = getObjectDiff(data.styles, DEFAULT_STYLES);
      onChange({
        content: data.content,
        tag: data.tag,
        alignment: data.alignment,
        styles: deleteNotTruthey(differedStyles)
      });
    }
  };

  const handleTagChange = newTag => {
    setInitialContent(content);
    setTag(newTag);
    notifyChange({
      content,
      tag: newTag,
      alignment,
      styles: textStyles
    });
  };

  const handleAlignmentChange = newAlignment => {
    setInitialContent(content);
    setAlignment(newAlignment);
    notifyChange({
      content,
      tag,
      alignment: newAlignment,
      styles: textStyles
    });
  };

  const updateStyle = debounce((styleKey, value) => {
    const newStyles = _objectSpread(_objectSpread({}, textStyles), {}, {
      [styleKey]: value
    });

    setTextStyles(newStyles);
    notifyChange({
      content,
      tag,
      alignment,
      styles: newStyles
    });
  }, 150);
  const composedEditableRef = useComposedRefs(editableRef, refs.setReference); // Sync external content changes

  useEffect(() => {
    if (!editable) return;
    setContent(prev => {
      const isChanged = prev !== defaultContent;
      if (!isChanged) return prev; // If content is changed externally, update the editable element

      if (editableRef.current) {
        editableRef.current.innerText = defaultContent || '';
      }

      return defaultContent || '';
    });
  }, [editable, defaultContent, editableRef]); // Sync external alignment changes

  useEffect(() => {
    if (!editable) return;
    setAlignment(prev => {
      return prev !== initialAlignment ? initialAlignment : prev;
    });
  }, [editable, initialAlignment]); // Sync external style changes

  useEffect(() => {
    if (!editable) return;
    setTextStyles(prev => {
      return !isEqual(prev, initialStyles) ? initialStyles : prev;
    });
  }, [editable, initialStyles]);
  const inlineStyles = useMemo(() => {
    var _theme$typography;

    const defaultStyles = ((_theme$typography = theme.typography) === null || _theme$typography === void 0 ? void 0 : _theme$typography[tag || 'h6']) || {};
    return {
      fontWeight: textStyles.bold ? 'bold' : defaultStyles.fontWeight,
      fontStyle: textStyles.italic ? 'italic' : defaultStyles.fontStyle,
      textDecoration: textStyles.underlined ? 'underline' : 'none',
      textAlign: alignment,
      color: textStyles.color || defaultStyles.color
    };
  }, [theme, textStyles, alignment, tag]);
  const CurrentTag = getElementTag(tag || defaultTag);

  if (!editable) {
    return /*#__PURE__*/_jsx(CurrentTag, {
      style: inlineStyles,
      className: clsx(commonStyles.title, commonStyles[`title--${tag}`], commonStyles[`title--${alignment}`]),
      children: content
    });
  } // TODO: refactor to use a container component
  //       so that all these unused editor-only
  //       events are not created
  // NOTE: Probably better to manage editing logic
  //       up one level in <Header>


  return /*#__PURE__*/_jsxs("div", {
    ref: containerRef,
    className: clsx(styles.editableTextContainer, styles[`editableTextContainer--${alignment}`], className),
    children: [isToolbarOpen ? /*#__PURE__*/_jsx(FloatingPortal, {
      children: /*#__PURE__*/_jsx(Toolbar, _objectSpread({
        theme: theme,
        ref: refs.setFloating,
        defaultTag: defaultTag,
        currentTag: tag || null,
        currentColor: (textStyles === null || textStyles === void 0 ? void 0 : textStyles.color) || inlineStyles.color || design.colors.gray100,
        isBold: Boolean(textStyles.bold),
        isItalic: Boolean(textStyles.italic),
        isUnderlined: Boolean(textStyles.underlined),
        alignment: alignment,
        style: floatingStyles,
        colorPallet: colorPallet,
        onTagChange: handleTagChange,
        onAlignmentChange: handleAlignmentChange,
        onStyleChange: updateStyle,
        onClose: () => handleOpenChange(false)
      }, getFloatingProps()))
    }) : null, /*#__PURE__*/_jsx(CurrentTag, _objectSpread(_objectSpread({
      id: id,
      ref: composedEditableRef,
      placeholder: !content ? placeholder : '',
      className: clsx(styles.editableTextContent, commonStyles.title, commonStyles[`title--${tag}`], commonStyles[`title--${alignment}`], styles[`editableTextContent--${alignment}`], {
        [styles['editableTextContent--focused']]: isToolbarOpen
      }),
      contentEditable: true,
      suppressContentEditableWarning: true,
      onInput: handleContentChange,
      onPaste: handlePaste,
      onFocus: () => {
        if (!isToolbarOpen) {
          handleOpenChange(true);
        }
      },
      style: inlineStyles
    }, getReferenceProps()), {}, {
      onKeyDown: e => {
        // disable line breaks
        if (e.key === 'Enter') {
          e.preventDefault();
        } // close on tab


        if (e.key === 'Tab') {
          handleOpenChange(false);
        }
      },
      children: initialContent
    }))]
  });
};

export default EditableText;

function getElementTag(tag) {
  if (tag === 'subheading') return 'div';
  if (tag === 'body') return 'p';
  return tag;
}